import { Modal } from "react-bootstrap";
import { X } from "lucide-react";
import "./HomeCookAllergyModal.css";

export const getHomeCookAllergyNote = (foodItemName) =>
  foodItemName
    ? `User confirmed they have no known allergies for ${foodItemName}.`
    : "User confirmed they have no known allergies for this food item.";

const HomeCookAllergyModal = ({
  show,
  foodItemName,
  foodImage,
  onConfirm,
  onClose,
  isLoading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop
      keyboard
      className="home-cook-allergy-modal-root"
      dialogClassName="home-cook-allergy-modal"
      contentClassName="home-cook-allergy-modal__content-wrap"
      backdropClassName="home-cook-allergy-modal-backdrop"
    >
      <div className="home-cook-allergy-modal__content">
        <div className="home-cook-allergy-modal__hero">
          {foodImage ? (
            <img
              src={foodImage}
              alt={foodItemName || "Food item"}
              className="home-cook-allergy-modal__image"
            />
          ) : (
            <div className="home-cook-allergy-modal__image home-cook-allergy-modal__image--placeholder" />
          )}
          <div
            className="home-cook-allergy-modal__hero-fade"
            aria-hidden="true"
          />
          <button
            type="button"
            className="home-cook-allergy-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} strokeWidth={2.25} />
          </button>
        </div>

        <div className="home-cook-allergy-modal__body">
          <h2 className="home-cook-allergy-modal__title">Please confirm</h2>
          <p className="home-cook-allergy-modal__message">
            Please review the details before continuing. By confirming, you
            acknowledge that you have <strong>no known allergies</strong> and
            accept full responsibility for your order.
          </p>

          <div className="home-cook-allergy-modal__actions">
            <button
              type="button"
              className="home-cook-allergy-modal__cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="home-cook-allergy-modal__confirm"
              onClick={onConfirm}
              disabled={isLoading}
            >
              Confirm
            </button>
          </div>

          <p className="home-cook-allergy-modal__note">
            This action cannot be undone.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default HomeCookAllergyModal;
